import React, { useState } from "react";
import { UncontrolledDropdown, Button } from "reactstrap";
import { Icon } from "../Component";
import miscService from "../../api/misc/misc";
import Swal from "sweetalert2";
import { Form, Modal as AntModal, Input } from "antd";
import { useDispatch } from "react-redux";
import { setHighlight } from "../../store/slices/misc/highlightSlice";
import { Link } from "react-router-dom";
import ExportToXlsx from "../../utils/exportToXlsx";
import {
  qwertyTextRule,
  stripNonQwertyChars,
} from "../../utils/inputValidation";

export enum ApplicationType {
  Procurement = "Procurement",
  Pms = "PMS",
  Wom = "WOM",
}

const reportConfiguration: any = {
  "view-purchase-order": {
    reportType: "Orders",
    reportModule: "orderBilling",
    applicationType: ApplicationType.Wom,
  },
  "view-invoice-list": {
    reportType: "Invoices",
    reportModule: "orderBilling",
    applicationType: ApplicationType.Wom,
  },
  "view-payments": {
    reportType: "Contractor Payments",
    reportModule: "womRaBills",
    applicationType: ApplicationType.Wom,
  },
  "material-list": {
    reportType: "Materials",
    reportModule: "masters",
    applicationType: ApplicationType.Wom,
  },
  "suppliers-list": {
    reportType: "Suppliers",
    reportModule: "masters",
    applicationType: ApplicationType.Wom,
  },
  "view-purchase-requests-list": {
    reportType: "Purchase Requests",
    reportModule: "transactions",
    applicationType: ApplicationType.Wom,
  },
  "view-budget-list": {
    reportType: "Budgets",
    reportModule: "transactions",
    applicationType: ApplicationType.Wom,
  },
  "view-rfqs": {
    reportType: "Quotations",
    reportModule: "transactions",
    applicationType: ApplicationType.Wom,
  },
  purchaseBySiteReport: {
    reportType: "Purchase by Site",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseBySiteDetailReport: {
    reportType: "Purchase by Site Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseBySupplier: {
    reportType: "Awarded To Supplier",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseBySupplierDetailReport: {
    reportType: "Awarded To Supplier Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseOrdersReport: {
    reportType: "Purchase Order",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  invoiceBySupplierReport: {
    reportType: "Invoice by Supplier",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseByMaterialReport: {
    reportType: "Purchase by Material",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseByMaterialDetailReport: {
    reportType: "Purchase by Material Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseByCategoryReport: {
    reportType: "Purchase by Category",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  purchaseByCategoryDetailReport: {
    reportType: "Purchase by Category Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  deliveryNoteDetailsReport: {
    reportType: "GRN Details List",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  supplierBalancesReport: {
    reportType: "Supplier Balances",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  supplierBalancesDetailReport: {
    reportType: "Supplier Balances Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  paymentsAgingSummaryReport: {
    reportType: "Payments Aging Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  paymentsAgingSummaryInvoiceReport: {
    reportType: "Payments Aging Summary Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  paymentsAgingReport: {
    reportType: "Payments Aging",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  paymentsReport: {
    reportType: "Payments Report",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  invoiceDetailsForPaymentsReport: {
    reportType: "Payments Report Details",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  materialsIssuedToSite: {
    reportType: "Materials Issued To Site",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  InventorySummaryReport: {
    reportType: "Inventory Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  InventoryValueReport: {
    reportType: "Inventory Value",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  InventoryTrackReport: {
    reportType: "Material Moment",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-tracking-report-list": {
    reportType: "Budget Tracking",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-consumption-report-list": {
    reportType: "Material Utilization Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  materialUtilizationSummaryDetailReport: {
    reportType: "Avg Material Utilized Breakup",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-request-summary-list": {
    reportType: "Material Request Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-issue-summary-list": {
    reportType: "Material Issue Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-utilized-summary-list": {
    reportType: "Material Utilized Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-damage-summary-list": {
    reportType: "Material Damage Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "/material-summary-list": {
    reportType: "Material Movement Summary",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  MaterialMovementSummaryDetailReport: {
    reportType: "Avg Material Movement Breakup",
    reportModule: "reports",
    applicationType: ApplicationType.Wom,
  },
  "view-work-order": {
    reportType: "Work Order List",
    reportModule: "womWorkOrder",
    applicationType: ApplicationType.Wom,
  },
  "Finalized-view-work-order": {
    reportType: "Work Order List",
    reportModule: "womWorkOrder",
    applicationType: ApplicationType.Wom,
  },
  "under-work-execution": {
    reportType: "Work Order List",
    reportModule: "womWorkOrder",
    applicationType: ApplicationType.Wom,
  },
  "closed-works": {
    reportType: "Work Execution ClosedWorks List",
    reportModule: "womWorkExecution",
    applicationType: ApplicationType.Wom,
  },
  "ra-bills-view-approved": {
    reportType: "RaBills List",
    reportModule: "womRaBills",
    applicationType: ApplicationType.Wom,
  },
  "work-boq-list": {
    reportType: "Work Boq list",
    reportModule: "womWorkBoq",
    applicationType: ApplicationType.Wom,
  },
  // ====== WOM REPORTS ======
  "wo-portfolio-summary": {
    reportType: "Work Order Portfolio Summary",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "wo-status-distribution": {
    reportType: "Work Order Status Distribution",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "wo-executed-pending-approved": {
    reportType: "Executed WOs Pending",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "executed-wos-approved": {
    reportType: "Executed WOs Approved",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "payments-released-summary": {
    reportType: "Payments Released Summary",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "payments-released-vouchers": {
    reportType: "Payments Released Vouchers",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "work-order-variance-summary": {
    reportType: "Work Order Variance Summary",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "contractor-acceptance-tracker": {
    reportType: "Contractor Acceptance Tracker",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "work-execution-pending-updates": {
    reportType: "Work Execution Pending Updates",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "work-execution-approved-remaining": {
    reportType: "Work Execution Approved vs Remaining",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "version-control-amendments": {
    reportType: "Version Control Amendments Register",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "ra-bills-status-register": {
    reportType: "RA Bills Status Register",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "ra-bill-aging": {
    reportType: "RA Bill Aging",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "deductions-ledger": {
    reportType: "Deductions Ledger",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "payments-register": {
    reportType: "Payments Register",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "outstanding-aging": {
    reportType: "Outstanding Aging",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "contractor-due-amount": {
    reportType: "Contractor Due Amount",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "contractor-due-amount-drilldown": {
    reportType: "Contractor Due Amount Drilldown",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "wo-vs-budget": {
    reportType: "WO Vs Budget",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
  "contractor-ledger": {
    reportType: "Contractor Ledger",
    reportModule: "womReports",
    applicationType: ApplicationType.Wom,
  },
};

const Export = ({
  data,
  moduleKey,
  reportType = "transactionFlow",
  showAsButton = true,
  flowType = "",
  disabled = false,
}: {
  data: any;
  moduleKey?: any;
  reportType?: any;
  showAsButton?: boolean;
  flowType?: string | null;
  disabled?: boolean;
}) => {
  const dispatch = useDispatch();
  const params = data;
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const handelExcelClick = () => {
    if (disabled) return;
    if (!moduleKey) {
      ExportToXlsx(data, "Excel");
    }
    setShowCommentsModal(true);
  };

  const getExtraPaginationParams = (moduleKey: any) => {
    const {
      selectFilter1,
      selectFilter2,
      selectFilter3,
      siteId,
      materialId,
      categoryId,
      contractorId,
      supplierId,
      customFilters,
    } = params;

    const toCsv = (val: any) =>
      Array.isArray(val) ? val.join(",") : val;

    const underExecutionFilters: any = {
      filterListType: "Under Executions",
    };
    if (customFilters?.siteId?.length) {
      underExecutionFilters.siteIds = toCsv(customFilters.siteId);
    }
    if (customFilters?.contractorName?.length) {
      underExecutionFilters.contractorIds = toCsv(customFilters.contractorName);
    }
    if (customFilters?.workOrderId?.length) {
      underExecutionFilters.workOrderIds = toCsv(customFilters.workOrderId);
    }
    if (customFilters?.status?.length) {
      underExecutionFilters.status = toCsv(customFilters.status);
    }

    const closedWorksFilters: any = {
      status: "Approved",
    };
    if (customFilters?.siteId?.length) {
      closedWorksFilters.siteIds = toCsv(customFilters.siteId);
    }
    if (customFilters?.contractorName?.length) {
      closedWorksFilters.contractorIds = toCsv(customFilters.contractorName);
    }
    if (customFilters?.workOrderId?.length) {
      closedWorksFilters.workOrderIds = toCsv(customFilters.workOrderId);
    }

    const extraparmsobj: any = {
      "view-purchase-order": {
        orderStatus: selectFilter1,
      },
      "view-invoice-list": {
        invoiceStatus: selectFilter1,
      },
      "material-list": {
        categoryFilters: selectFilter1,
      },
      "suppliers-list": {
        categoryFilters: selectFilter1,
      },
      "view-purchase-requests-list": {
        status: selectFilter1,
      },
      "view-budget-list": {
        status: selectFilter1,
      },
      "view-rfqs": {
        overallStatus: selectFilter1,
      },
      "view-work-order": {
        status: selectFilter1,
      },
      "Finalized-view-work-order": {
        filterListType: "Finalized",
        status: selectFilter1,
      },
      "under-work-execution": underExecutionFilters,
      "closed-works": closedWorksFilters,
    };
    return extraparmsobj[moduleKey];
  };

  const comments = async (comments: any): Promise<boolean> => {
    try {
      const {
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        searchQuery,
        dateRange,
        customDateRange,
        siteId,
        materialId,
        categoryId,
        contractorId,
        supplierId,
        page, //reports
        flowType: dataFlowType
      } = params;

      const config = reportConfiguration[moduleKey];
      const isWomReport = config?.reportModule === "womReports";

      const apiResponse = await miscService.excelExportRequest({
        ...reportConfiguration[moduleKey],
        comments,
        paginationData: {
          ...getExtraPaginationParams(moduleKey),
          pageSize: pageSize,
          startDate: dateRange?.from,
          endDate: dateRange?.to,
          flowType: dataFlowType || flowType || undefined,
          ...(reportType == "transactionFlow"
            ? {
                sortOrder: sortOrder,
                direction: direction,
                pageDiff: pageDiff,
                searchQuery: searchQuery,
              }
            : {
                page: page || 1,
                contractorIds: contractorId ? contractorId : undefined,
                siteIds: siteId ? siteId : undefined,
                supplierIdS: supplierId ? supplierId : undefined,
                materialIds: materialId ? materialId : undefined,
                categoryIds: categoryId ? categoryId : undefined,
              }),
          ...(isWomReport ? { page: page || 1 } : {}),
        },
      });
      const { status, message } = apiResponse || {};
      if (status) {
        dispatch(setHighlight(true));
        Swal.fire({
          title: "Success",
          text: "Request Submited Successfully",
          icon: "success",
        });
        return true;
      }
      Swal.fire({
        title: "Failed",
        text: message || "Export request could not be submitted",
        icon: "error",
      });
      return false;
    } catch (error: any) {
      console.error("Error loading data:", error);
      Swal.fire({
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Export request failed",
        icon: "error",
      });
      return false;
    }
  };

  return (
    <>
      {showAsButton ? (
        <UncontrolledDropdown size={"md"}>
          {" "}
          <div
            onClick={() => handelExcelClick()}
            className="btn btn-white btn-outline-light"
            style={{
              opacity: disabled ? 0.6 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
              pointerEvents: disabled ? "none" : "auto",
            }}
          >
            <Icon name="download-cloud"></Icon>
            <span>Export </span>
          </div>
        </UncontrolledDropdown>
      ) : (
        <Link
          to={`#`}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
              return;
            }
            handelExcelClick();
          }}
          style={{
            opacity: disabled ? 0.6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          <Icon name="download-cloud"></Icon>
          <span>Export</span>
        </Link>
      )}
      {moduleKey && (
        <CommentsModal
          isModalVisible={showCommentsModal}
          setIsModalVisible={setShowCommentsModal}
          comments={comments}
        />
      )}
    </>
  );
};

const CommentsModal = ({
  isModalVisible,
  setIsModalVisible,
  comments,
}: any) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (isModalVisible) {
      form.resetFields();
    }
  }, [isModalVisible, form]);

  const handleCancel = () => {
    if (submitting) return;
    form.resetFields();
    setIsModalVisible(false);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      try {
        await comments(values.reason);
      } finally {
        setSubmitting(false);
        form.resetFields();
        setIsModalVisible(false);
      }
    } catch (info) {
      console.log("Validate Failed:", info);
    }
  };
  return (
    <AntModal
      title="Comments"
      visible={isModalVisible}
      footer={null} // Remove the default footer buttons
      onCancel={handleCancel}
      destroyOnClose
      maskClosable={!submitting}
      closable={!submitting}
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Comments"
          rules={[
            { required: true, message: "Please input your Comments!" },
            qwertyTextRule({ maxLength: 500, fieldLabel: "Comments" }),
          ]}
          normalize={(value: string) => stripNonQwertyChars(value)}
        >
          <Input.TextArea
            placeholder="Type your Comments here..."
            maxLength={500}
            showCount
          />
        </Form.Item>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={handleOk}
                disabled={submitting}
              >
                {submitting ? "Requesting..." : "Request"}
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
                disabled={submitting}
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </AntModal>
  );
};

export default Export;
